import React, { Fragment } from "react";
import Totals from "./Totals";
import { ListGroup, ListGroupItem } from "reactstrap";
import {
  getCompletedItems,
  getConfirmedItems,
  getRecommendedItems,
  getRequiredItems,
} from "../modules/items";
import { connect } from "react-redux";
import {
  compose,
  setDisplayName,
  withProps,
  branch,
  renderComponent,
} from "recompose";
import { isEmpty } from "lodash";

const mapStateToProps = (state) => ({
  items: state.items.items,
  confirmedItems: getConfirmedItems(state),
  requiredItems: getRequiredItems(state),
  completedItems: getCompletedItems(state),
  recommendedItems: getRecommendedItems(state),
  discounts: state.discounts.discounts,
  currentContract: state.contracts.currentContract,
  currentDealer: state.dealers.currentDealer,
  role: state.settings.role,
});

const withReduxState = connect(mapStateToProps);

const TotalSection = ({
  items,
  requiredItems,
  recommendedItems,
  confirmedItems,
  completedItems,
  currentContract,
  discounts,
  role,
  currentDealer
}) => (
  <>
    {role === "staff" && (
      <div className="row">
        <div className="col">
          <ListGroup flush>
            {![
              "customer_confirmation_needed",
              "waiting_for_service",
              "in_service",
              "hold",
              "waiting_for_parts",
              "waiting_for_invoice",
              "waiting_for_payment",
              "waiting_for_pickup",
              "completed",
            ].includes(currentContract.aasm_state) &&
              role === "staff" && (
                <ListGroupItem>
                  <Totals
                    title="All Items"
                    items={items}
                    contract={currentContract}
                    discounts={discounts}
                    role={role}
                    showDiscount
                    isMain
                    taxRate={currentDealer.tax_rate}
                  />
                </ListGroupItem>
              )}
            {[
              "customer_confirmation_needed",
              "waiting_for_service",
              "waiting_for_payment",
              "in_service",
              "hold",
              "waiting_for_parts",
            ].includes(currentContract.aasm_state) && (
              <ListGroupItem>
                <Totals
                  title="Confirmed Items"
                  items={confirmedItems}
                  contract={currentContract}
                  discounts={discounts}
                  role={role}
                  showDiscount
                  showExpress
                  isMain
                  taxRate={currentDealer.tax_rate}
                />
              </ListGroupItem>
            )}
            {[
              "waiting_for_invoice",
             
              "waiting_for_pickup",
              "completed",
            ].includes(currentContract.aasm_state) && (
              <ListGroupItem>
                <Totals
                  title="Completed Items"
                  items={completedItems}
                  contract={currentContract}
                  discounts={discounts}
                  role={role}
                  showDiscount
                  showExpress
                  isMain
                  taxRate={currentDealer.tax_rate}
                />
              </ListGroupItem>
            )}
            {[
              "in_diagnostic",
              "approve_diagnostic",
              "customer_confirmation_needed",
            ].includes(currentContract.aasm_state) &&
              role === "staff" && (
                <Fragment>
                  <ListGroupItem>
                    <Totals
                      title="Required Items"
                      items={requiredItems}
                      contract={currentContract}
                      discounts={discounts}
                      role={role}
                      showDiscount
                      taxRate={currentDealer.tax_rate}
                    />
                  </ListGroupItem>
                  <ListGroupItem>
                    <Totals
                      title="Recommended Items"
                      items={recommendedItems}
                      contract={currentContract}
                      discounts={discounts}
                      role={role}
                      showDiscount
                      taxRate={currentDealer.tax_rate}
                    />
                  </ListGroupItem>
                </Fragment>
              )}
          </ListGroup>
        </div>
      </div>
    )}
    {role === "customer" &&
      [
        "waiting_for_invoice",
        "waiting_for_payment",
        "waiting_for_pickup",
        "completed",
        "customer_confirmation_needed",
        "waiting_for_service",
        "in_service",
        "hold",
        "waiting_for_parts",
      ].includes(currentContract.aasm_state) && (
        <Totals
          items={confirmedItems}
          contract={currentContract}
          discounts={discounts}
          role={role}
          showDiscount
          showExpress
          isMain
          taxRate={currentDealer.tax_rate}
        />
      )}
  </>
);

const EmptyMessage = () => (
  <h4 className="text-muted text-right px-1">
    Add services to see contract's totals
  </h4>
);

export default compose(
  setDisplayName("TotalSection"),
  withReduxState,
  withProps(({ currentDealer, currentContract, values }) => ({
    currentContract: currentContract
      ? Object.assign(currentContract, values)
      : Object.assign({}, values, { dealer: currentDealer }),
  })),
  branch(
    ({ items, currentContract }) =>
      isEmpty(items) && currentContract.aasm_state !== "pending_diagnostic",
    renderComponent(EmptyMessage)
  )
)(TotalSection);
